/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_Trust_SubInputs */

const en_mk_team_trust_sub = /** @type {(inputs: Mk_Team_Trust_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every control below is optional and switched on per project. Without them, the agent team runs as usual.`)
};

const id_mk_team_trust_sub = /** @type {(inputs: Mk_Team_Trust_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua kendali di bawah ini opsional dan bisa dinyalakan per proyek. Tanpa itu, tim agent berjalan seperti biasa.`)
};

/**
* | output |
* | --- |
* | "Every control below is optional and switched on per project. Without them, the agent team runs as usual." |
*
* @param {Mk_Team_Trust_SubInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_trust_sub = /** @type {((inputs?: Mk_Team_Trust_SubInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_Trust_SubInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_trust_sub(inputs)
	return en_mk_team_trust_sub(inputs)
});